import config from '../config/constants'
import _ from 'lodash'

function inserted(el, binding) {
  const callback = _.debounce(binding.value, config.DEFAULT_DEBOUNCED_RESIZE)
  const options = binding.options || { passive: true }

  window.addEventListener('resize', callback, options)
  el._onResize = {
    callback,
    options,
  }

  if (!binding.modifiers || !binding.modifiers.quiet) {
    callback()
  }
}

function unbind(el) {
  const { callback, options } = el._onResize

  window.removeEventListener('resize', callback, options)
  delete el._onResize
}

export default {
  name: 'debounced',
  inserted,
  unbind,
}
